<template>
	<div>
		<div class="breadcrumb">
			<span style="color:#666">首页</span>
			<span v-for="(item,index) in router_matched">
				/ {{item.meta.title}}
			</span>

			<div class="admin_panel" style="float:right;margin-right:30px">
				<el-dropdown>
					<span class="el-dropdown-link">
						{{admin_name}} <i class="el-icon-arrow-down el-icon--right"></i>
					</span>
					<el-dropdown-menu slot="dropdown">
						<el-dropdown-item icon="el-icon-circle-close"><span @click="adminLogout()">退出登录</span> </el-dropdown-item>

					</el-dropdown-menu>
				</el-dropdown>
			</div>
			<!-- <div class="app-wrap" style="">
				<el-scrollbar class="scroll-container">
					<el-tag :type="now_url == item.route ? 'success' : 'info' "  style="margin-left:10px;cursor:pointer;" @click="tabClick(item.route)" @close="tabRemove(item.route)" :key="item.name" v-for="(item, index) in openTab" :label="item.name" :name="item.route"
					 closable>{{item.name}}</el-tag>
				</el-scrollbar>
			</div> -->
		</div>

	</div>
</template>

<script>
	import storage from 'good-storage'
	import {
		logout
	} from '@/api/login'
	import Qs from 'qs'
	import {
		getToken,
		removeToken
	} from '@/tool/cookie'
	export default {
		name: "topnav",
		data() {
			return {
				admin_name: getToken("admin_name"),
				now_url:''
			}
		},
		props: {
			router_matched: {},
		},
		methods: {
			// 退出登录
			adminLogout() {
				logout(Qs.stringify()).then(response => {
					// 清除cookie
					removeToken('admin_name');
					removeToken('login_uid');
					removeToken('token');
					removeToken('manager_role');
					storage.remove('manager_role')
					// 清除路由状态
					this.$store.state.openTab = [];
					this.$store.state.activeIndex = '/';
					//  跳转到首页
					this.$router.push({
						path: '/login'
					})
				})
			},
			//tab标签点击时，切换相应的路由
			tabClick(tab) {
				if(this.now_url != tab){
					this.$router.push({
						path: tab
					});
				}
			},
			//移除tab标签
			tabRemove(targetName) {
				//首页不删
				if (targetName == '/') {
					return
				}
				this.$store.commit('delete_tabs', targetName);
				// console.log(this.openTab);
				// console.log(this.activeIndex);
				// console.log(targetName);
				if (this.activeIndex === targetName) {
					// 设置当前激活的路由
					if (this.openTab && this.openTab.length >= 1) {
						// console.log('=============', this.openTab[this.openTab.length - 1].route)
						this.$store.commit('set_active_index', this.openTab[this.openTab.length - 1].route);
						this.$router.push({
							path: this.activeIndex
						});
					} else {
						this.$router.push({
							path: '/'
						});
					}
				}
			}
		},
		// mounted() {
		// 	this.now_url = this.$route.path;
		// 	// console.log(this.$route.path)
		// 	// 刷新时以当前路由做为tab加入tabs
		// 	// 当前路由不是首页时，添加首页以及另一页到store里，并设置激活状态
		// 	// 当当前路由是首页时，添加首页到store，并设置激活状态
		// 	if (this.$route.path != '/') {
		// 		// console.log(this.$route);
		// 		this.$store.commit('add_tabs', {
		// 			route: '/',
		// 			name: '后台首页'
		// 		});
		// 		this.$store.commit('add_tabs', {
		// 			route: this.$route.path,
		// 			name: this.$route.meta.title
		// 		});
		// 		this.$store.commit('set_active_index', this.$route.path);
		// 	} else {

		// 		this.$store.commit('add_tabs', {
		// 			route: '/',
		// 			name: '后台首页'
		// 		});
		// 		this.$store.commit('set_active_index', '/');
		// 		// this.$router.push('/');
		// 	}
		// },
		// computed: {
		// 	openTab() {
		// 		return this.$store.state.openTab;
		// 	},
		// 	activeIndex: {
		// 		get() {
		// 			return this.$store.state.activeIndex;
		// 		},
		// 		set(val) {
		// 			this.$store.commit('set_active_index', val);
		// 		}
		// 	}
		// },
		// watch: {
		// 	'$route'(to, from) {
		// 		this.now_url = this.$route.path;
		// 		//判断路由是否已经打开
		// 		//已经打开的 ，将其置为active
		// 		//未打开的，将其放入队列里
		// 		let flag = false;
		// 		// console.log(this.openTab)
		// 		// console.log(to)
		// 		for (let item of this.openTab) {
		// 			if (item.name === to.meta.title) {
		// 				// console.log('to.path', to.path);
		// 				this.$store.commit('set_active_index', to.path)
		// 				flag = true;
		// 				break;
		// 			}
		// 		}

		// 		if (!flag) {
		// 			this.$store.commit('add_tabs', {
		// 				route: to.path,
		// 				name: to.meta.title
		// 			});
		// 			this.$store.commit('set_active_index', to.path);
		// 		}

		// 	}
		// },

	}
</script>

<style scoped>
	.scroll-container {
	  white-space: nowrap;
	  /* position: relative; */
	  overflow: hidden;
	  width: 100%;
	}
</style>
